/**
 * Maps a mail-sender document_type to the collection(s)/use_case needed to
 * generate its document(s) via TemplateDocumentButton (template-documents/generatePDF).
 *
 * ANOUNCEMENT, OTHER_PENSIONER and OTHER_OWNER stay on the legacy
 * generateDocuments() path: ANOUNCEMENT's use_case expects a Supervision id
 * (mailSender only stores Pensioner ids), and OTHER_PENSIONER/OTHER_OWNER
 * have no use_case registered on the new endpoint.
 *
 * @function
 * @param {string} documentType - The mailSender document_type.
 * @returns {Object|null} Dispatch config, or null if the type is unknown.
 */
export const collectionDispatch = (documentType) => {
  const configs = {
    OWNER_WISH: {
      idsField: 'owners',
      collection: 'Owner',
      useCase: 'OWNER_WISH'
    },
    PENSIONER_WISH: {
      idsField: 'pensioners',
      collection: 'Pensioner',
      useCase: 'PENSIONER_WISH'
    },
    OWNER_EXPLANATORY_DOCUMENT: {
      idsField: 'owners',
      collection: 'Owner',
      useCase: 'OWNER_EXPLANATORY_DOCUMENT',
      blankUseCase: 'OWNER_EXPLANATORY_WITHOUT_NAME',
      blankCollection: 'Owner'
    },
    PENSIONER_EXPLANATORY_DOCUMENT: {
      idsField: 'pensioners',
      collection: 'Pensioner',
      useCase: 'PENSIONER_EXPLANATORY_DOCUMENT',
      blankUseCase: 'PENSIONER_EXPLANATORY_WITHOUT_NAME',
      blankCollection: 'Pensioner'
    },
    VETERINARIAN_ADVERT: {
      idsField: 'veterinarians',
      collection: 'Veterinarian',
      useCase: 'VETERINARIAN_ADVERT'
    },
    GROOMER_ADVERT: {
      idsField: 'groomers',
      collection: 'Groomer',
      useCase: 'GROOMER_ADVERT'
    },
    ANOUNCEMENT: {
      multi: [
        {
          idsField: 'pensioners',
          useCase: 'ANOUNCEMENT',
          collection: 'Pensioner'
        },
        {
          useCase: 'ANOUNCEMENT',
          collection: 'Supervision',
          blankUseCase: 'ANOUNCEMENT_WITHOUT_NAME',
          blankCollection: 'Supervision'
        }
      ]
    },
    OTHER_PENSIONER: { legacy: true },
    OTHER_OWNER: { legacy: true }
  };

  return configs[documentType] || { legacy: true };
};
